import { render, staticRenderFns } from "./PeersPlays.vue?vue&type=template&id=6dd5a284&scoped=true"
import script from "./PeersPlays.vue?vue&type=script&lang=js"
export * from "./PeersPlays.vue?vue&type=script&lang=js"
import style0 from "./PeersPlays.vue?vue&type=style&index=0&id=6dd5a284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5a284",
  null
  
)

export default component.exports